import * as yup from "yup";

export const profileSchema= yup.object().shape({
  address1: yup.string().required().min(4).matches(/^[A-Z/a-z/0-9/ /\s/]+$/),
  city: yup.string().required().min(4),
  zip: yup.string().required().matches(/^((\d{3,5}-\d{1,4})|(\d{3,5})|([A-Z]\d[A-Z]\s\d[A-Z]\d))$/, "ZIP number is invalid"),
});